export default __webpack_public_path__ + "img/btn-allread.a4a48057.svg";